import {
  ActionBody,
  Body,
  Columnz,
  DataTablez,
  RenderHeader,
  StatusBody,
  TimeBody,
  useGetParams,
} from "@/components/DataTable";
import { Dropdownz, GridForm, Inputz } from "@/components/ListForm";
import { Button, Dialog, Dropdown, InputText } from "@/uiCore";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useCountListSheetDetail, useListSheetDetail } from "../util";
import { updateDetailSheet, updateDetailSheetV2 } from "../api";
import { useListCategory } from "@/modules/categories/category/util";
import { showToast } from "@/redux/features/toast";
import { listToast } from "@/utils";
import { useDispatch } from "react-redux";
const Header = (props) => {
  const {
    setParamsPaginator,
    paramsPaginator,
    categories,
    exchanges,
    users,
    news,
  } = props;
  const [filter, setFilter] = useState({});

  return (
    <GridForm
      paramsPaginator={paramsPaginator}
      setParamsPaginator={setParamsPaginator}
      filter={filter}
      setFilter={setFilter}
      className="lg:col-9"
    >
      <Dropdownz
        value={filter.news_id}
        options={news}
        placeholder="Chọn sự kiện"
        optionLabel="title"
        onChange={(e) => setFilter({ ...filter, news_id: e.target.value })}
      />
      {/* <Dropdownz
        value={filter.type_news}
        options={news_types}
        placeholder="Chọn loại sự kiện"
        onChange={(e) => setFilter({ ...filter, type_news: e.target.value })}
      /> */}
      <Dropdownz
        value={filter.category_id}
        options={categories}
        placeholder="Chọn dự án"
        onChange={(e) => setFilter({ ...filter, category_id: e.target.value })}
      />
      <Dropdownz
        value={filter.exchange_id}
        options={exchanges}
        placeholder="Chọn đơn vị"
        onChange={(e) => setFilter({ ...filter, exchange_id: e.target.value })}
      />
      <Dropdownz
        value={filter.user_id}
        options={users}
        placeholder="Chọn nhân viên"
        onChange={(e) => setFilter({ ...filter, user_id: e.target.value })}
      />
    </GridForm>
  );
};
const UpdateSheet = () => {
  const initParams = useGetParams();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [paramsPaginator, setParamsPaginator] = useState(initParams);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [infos, setInfos] = useState({});
  const list = useListSheetDetail({ ...paramsPaginator });
  const total = useCountListSheetDetail({ ...paramsPaginator });
  const header = RenderHeader({
    title: "Danh sách trang tính",
    // exports: {
    //   route: "/list_sheet/export",
    //   action: () => exportRegisterNews(paramsPaginator),
    //   totalRecords: totalRecords,
    //   file: "list_sheet.xlsx",
    // },
  });
  async function fetchDataSubmit() {
    const response = await updateDetailSheetV2({
      id: infos?.id,
      category_id: infos?.category_id,
      website: infos?.website,
    });
    if (response) setLoading(false);
    if (response.data.status) {
      dispatch(
        showToast({ ...listToast[0], detail: `Cập nhật thông tin thành công!` })
      );
      handleHide();
      setParamsPaginator((pre) => ({ ...pre, render: !pre.render }));
    } else dispatch(showToast({ ...listToast[1], detail: response.data.mess }));
  }

  const handleSubmit = () => {
    setLoading(true);
    // if (!infos?.category_id) {
    //   dispatch(showToast({ ...listToast[1], detail: "Vui lòng chọn dự án" }));
    //   setLoading(false);
    // } else {
    fetchDataSubmit();
    // }
  };

  const listCategory = useListCategory({ ...paramsPaginator });
  const handleProject = (e) => {
    setVisible(true);
    setInfos({ ...e, ...infos });
  };
  const handleHide = () => {
    setVisible(false);
    setInfos({});
  };
  const footerContent = (
    <div>
      <Button
        label="Hủy"
        icon="pi pi-times"
        onClick={() => handleHide()}
        className="p-button-text"
      />
      <Button
        label="Cập nhật"
        icon="pi pi-check"
        onClick={() => handleSubmit()}
        loading={loading}
        autoFocus
      />
    </div>
  );
  return (
    <div className="card">
      <Dialog
        header="Cập nhật thông tin trang tính"
        visible={visible}
        position="top"
        style={{ width: "60vw", height: "60vh" }}
        onHide={() => handleHide()}
        draggable={false}
        // resizable={false}
        footer={footerContent}
      >
        <div className="grid">
          <div className="col-6">
            <label htmlFor="username">ID trang tính</label>
            <InputText
              id="username"
              value={infos?.id_sheet}
              onChange={(e) => setInfos({ ...infos, id_sheet: e.target.value })}
              className="w-full my-1"
              readOnly
            />
          </div>
          <div className="col-6">
            <label htmlFor="username">Tên tiêu đề</label>
            <InputText
              id="username"
              value={infos?.title}
              onChange={(e) => setInfos({ ...infos, title: e.target.value })}
              className="w-full my-1"
              readOnly
            />
          </div>
          <div className="col-6">
            <label htmlFor="username">LandingPage/Website</label>
            <InputText
              id="username"
              value={infos?.website}
              onChange={(e) => setInfos({ ...infos, website: e.target.value })}
              placeholder="Nhập link Landing Page/Website"
              className="w-full my-1"
            />
          </div>
          <div className="col-6">
            <label htmlFor="cate" className="">
              Dự án
            </label>
            <Dropdown
              id="cate"
              value={infos?.category_id}
              onChange={(e) =>
                setInfos({ ...infos, category_id: e.target.value })
              }
              options={listCategory}
              optionLabel="cb_title"
              optionValue="cb_id"
              placeholder="Chọn dự án"
              className="w-full my-1"
              checkmark={true}
              highlightOnSelect={false}
            />
          </div>
          <div className="col-6"></div>
        </div>
      </Dialog>
      <DataTablez
        value={list}
        header={header}
        title="danh sách trang tính"
        totalRecords={total}
        paramsPaginator={paramsPaginator}
        setParamsPaginator={setParamsPaginator}
      >
        <Columnz field="id_sheet" header="ID Trang tính " />
        <Columnz field="title" header="Tên trang tính " />
        <Columnz
          body={(e) => (
            <>
              {e?.website || e?.website == null ? (
                <span className="">{e?.website}</span>
              ) : (
                <span>N/A</span>
              )}
            </>
          )}
          header="Website/LandingPage"
        />
        <Columnz
          body={(e) => (
            <span>
              {listCategory?.find((i) => i?.cb_id == e?.category_id)?.cb_title}
            </span>
          )}
          header="Dự án "
        />
        <Columnz
          header="Ngày tạo"
          body={(e) => TimeBody(e?.created_at)}
          bodyStyle={{ textAlign: "center" }}
        />
        <Columnz
          header="Cập nhật gần nhất"
          body={(e) => TimeBody(e?.updated_at)}
          bodyStyle={{ textAlign: "center" }}
        />
        <Columnz
          header="Trạng thái"
          body={(e) =>
            StatusBody(e, {
              route: "/list_sheet/update",
              action: updateDetailSheet,
            })
          }
          bodyStyle={{ textAlign: "center" }}
        />
        <Columnz
          header="Chỉnh sửa"
          body={(e) => (
            <i
              style={{ color: "#6366F1" }}
              className="pi pi-file-edit ml-3 text-2xl cursor-pointer rounded"
              onClick={() => handleProject(e)}
            ></i>
          )}
          style={{ minWidth: "8rem" }}
          bodyStyle={{ textAlign: "center" }}
        />
      </DataTablez>
      <div className="w-full justify-content-end flex px-3 pt-2">
        <Button
          type="button"
          onClick={() => navigate("/list_sheet")}
          label="Trở về"
          className="ml-2"
          severity="secondary"
          size="small"
          outlined
        />
      </div>
    </div>
  );
};
export default UpdateSheet;
